<div class="tabs" id="tabs-1" style="background: white;">
        


  
  <div class="form-row">
    <label style="font-weight: bold; font-size: x-large; text-align: center;">Hha Certified Competency Exam<br>
        (Examen De Competencia Por Escrito Del a Yudante De Salud En El Hogar (HHA))</label>
  
  </div><br><br>
  
  
     
  <form id="certifiedexamform" [formGroup]="regForm"  (ngSubmit)="step14Submitted(regForm)" > 
        
        
    <div class="container-fluid anyClass">

    <br>


    <div class="row">
            <div class="col-sm-12  col-md-12 col-lg-12  ">


<div class="form-group">

<div class="questionContainer radius">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 1</label> When giving a bed bath, the aide should :<hr />
            Cuando da un bafio de esponja, el ayudante debe:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                        <input type="radio" formControlName="Question1"  value="1" required/>First wash the client's face &#47; &#47; &#47;
                        Primero lavar el rostro del cliente.
                    </label>
                </li>
                <li>
                    <label>
                        <input type="radio" formControlName="Question1"  value="2" required/>Allow the client to wash his or her private areas if he or she can &#47; &#47; &#47;
                        Permitir al cliente lavarse las partes privadas si puede.
                    </label>
                </li>
                <li>
                    <label>
                        <input type="radio" formControlName="Question1"  value="3" required/>Change the bath water after cleaning the client's feet &#47; &#47; &#47;
                        Cambiar el agua del ba&#0241;o. despu&#0233;s de Iimpiar los pies del cliente. ;
                    </label>
                </li>
                <li>
                    <label>
                        <input type="radio" formControlName="Question1"  value="4" required/>All of the above &#47; &#47; &#47;
                        Todo lo anterior.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add1c" name="add1c" value=""/>
        <input type="hidden" name="qc1score2" id="qc1score2" value=""/>

    </div>



    <div class="questionContainer">
        <div class="question">
             <label style="font-weight: bold;font-size: 20px;">Question 2</label>  If giving a bed bath, you would need:<hr />Si da un ba&#0241;o de esponja, necesitar&#0255;:
            <div class="answers">
                <ul>
                    <li>
                        <label>
                            <input type="radio" formControlName="Question2"  value="1" required/>Soap&#47; &#47; &#47;
                            Jab&#0243;n.
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="radio" formControlName="Question2"  value="2" required/>A wash cloth&#47; &#47; &#47;
                            Una esponja.
                        </label>
                    </li>
                    <li>
                        <label>
                        <input type="radio" formControlName="Question2"  value="3" required/>A wash basin &#47; &#47; &#47;
                            Un cuenco de ba&#0241;o.
                        </label>
                    </li>
                    <li>
                        <label>
                        <input type="radio" formControlName="Question2"  value="4" required/>All of the above &#47; &#47; &#47;
                            Todo lo anterior.
                        </label>
                    </li>
                </ul>
            </div>

            <input type="hidden" class="add" id="add2c" name="add2c" value=""/>
            <input type="hidden" name="qc2score2" id="qc2score2" value=""/>

        </div>


        <div class="questionContainer  ">
            <div class="question">
                 <label style="font-weight: bold;font-size: 20px;">Question 3</label>  Which of the following should NOT occur while giving a client a tub bath?
                <hr />&#191;Cu&#0255;l de las siguientes acciones NO debe ocurrir cuando da al cliente un ba&#0241;o en Ia ba&#0241;adera?
            </div>
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question3"  value="1" required/>Assist the client to undress if he or she needs the help &#47; &#47; &#47;
                        Ayudar al cliente a desvestirse si necesita ayuda.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question3"  value="2" required/>Allow visitors to watch. &#47; &#47; &#47;
                        Permitir a los visitantes que observen.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question3"  value="3" required/>Asist the client to the bathroom if needed. &#47; &#47; &#47;
                        Ayudar al cliente hasta el ba&#0241;o si lo necesita.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question3"  value="4" required/>Help the client wash him/herself as needed. &#47; &#47; &#47;
                        Ayudar al cliente a lavarse si lo necesita.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add3c" name="add3c" value=""/>
        <input type="hidden" name="qc3score2" id="qc3score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
             <label style="font-weight: bold;font-size: 20px;">Question 4</label>  You go to Mrs. Adam's house on Monday morning and as you are giving her a bath, you notice many suspicious looking bruises.  When you ask Mrs. Adams about the bruises, she says, "I don't want to talk about it." You should: <hr />
            El lunes por la ma&#0241;ana, usted va al hogar de la Sra. Adams y mientras le da un ba&#0241;o, nota muchos hematomas de aspecto sospechoso. Cuando le pregunta a la Sra. Adams por los hematomas, ella dice: "No quiero hablar sobre ese tema". Usted debe:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question4"  value="1" required/>Respect Mrs. Adam's wishes and do nothing.
                        &#047; &#047; Respetar los deseos de la Sra. Adams y no hacer nada.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question4"  value="2" required/>Call your supervisor and report the bruises.
                        &#047; &#047; &#047; Llamar al supervisor e informarle acerca de los hematomas.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question4"  value="3" required/>Call her son at work and ask him if he hit her.
                        &#047; &#047; &#047; Llamar a su hijo al trabajo y preguntarle si &#0233;l la golpe&#0243;.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question4"  value="4" required/>Ignore the problem.
                        &#047; &#047; &#047; lgnorar el problema.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add4c" name="add4c" value=""/>
        <input type="hidden" name="qc4score2" id="qc4score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
             <label style="font-weight: bold;font-size: 20px;">Question 5</label>  The purpose of mouth care for a client is to: <hr />
            El objetivo del cuidado bucal para un cliente es:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question5"  value="1" required/>Improve the client/aide relationship. &#047; &#047; &#047;
                        Mejorar la relaci&#0243;n entre el cliente y el ayudante.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question5"  value="2" required/>Help the older person speak more clearly. &#047; &#047; &#047;
                        Ayudar a la persona anciana a hablar con mayor claridad.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question5"  value="3" required/>Keep the client's teeth and gums healthy. &#047; &#047; &#047;
                        Mantener sanos los dientes y las enc&#0237;as del cliente.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question5"  value="4" required/>None of the above. &#047; &#047; &#047;
                        Ninguna de las opciones anteriores.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add5c" name="add5c" value=""/>
        <input type="hidden" name="qc5score2" id="qc5score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
             <label style="font-weight: bold;font-size: 20px;">Question 6</label>  The first step when transferring a client out of bed to a wheelchair is:<hr />
            El primer paso cuando se pasa a un cliente de la cama a una silla de ruedas es:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question6"  value="1" required/>Pull back the covers on the bed.
                        &#047; &#047; &#047;Correr las mantas de la cama.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question6"  value="2" required/>Dangle the client's legs over the bed.
                        &#047; &#047; &#047;Hacer colgar las piernas del cliente sobre la cama.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question6"  value="3" required/>Tell the client what you are going to do.
                        &#047; &#047; &#047;Decir al cliente lo que usted har&#0225;.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question6"  value="4" required/>Put on the client's slippers.
                        &#047; &#047; &#047;Colocarle las pantuflas al cliente.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add6c" name="add6c" value=""/>
        <input type="hidden" name="qc6score2" id="qc6score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
             <label style="font-weight: bold;font-size: 20px;">Question 7</label>  Before transferring the client to the wheelchair.  The MOST important thing the aide should do:
            <hr />Antes de pasar al cliente a la silla de ruedas, lo M&#0193;S importante que el ayudante debe bacer es:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question7"  value="1" required/>Make sure the client is dressed.
                        &#047; &#047; &#047; Asegurarse de que el cliente est&#0233; vestido.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question7"  value="2" required/>Lock the wheels of the wheelchair.
                        &#047; &#047; &#047; Trabar las ruedas de la silla de ruedas.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question7"  value="3" required/>Offer the client the bedpan.
                        &#047; &#047; &#047; Ofrecer la chata al cliente.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question7"  value="4" required/>Bathe the client.
                        &#047; &#047; &#047; Ba&#0241;ar al cliente.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add7c" name="add7c" value=""/>
        <input type="hidden" name="qc7score2" id="qc7score2" value=""/>

    </div>

    <div class="questionContainer">
        <div class="question">
             <label style="font-weight: bold;font-size: 20px;">Question 8</label>  When walking with a client who has weakness on one side, the aide should: <hr />
            Cuando camina con un cliente que tiene debilidad en un lado del cuerpo, el ayudante debe:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question8"  value="1" required/>Walk on the client's weak side.
                        &#047; &#047;&#047;Caminar del lado en el que el cliente tiene la debilidad.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question8"  value="2" required/>Walk on the client's strong side.
                        &#047; &#047;&#047;Caminar del lado en el que el cliente no tiene la debilidad.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question8"  value="3" required/>Stay near the furniture, in case the client starts to fall.
                        &#047; &#047;&#047;Mantenerse cerca de los muebles, en caso de que el cliente comience a caer.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question8"  value="4" required/>Walk slightly ahead of the client.
                        &#047; &#047;&#047;Caminar un poco m&#0225;s adelante del cliente.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add8c" name="add8c" value=""/>
        <input type="hidden" name="qc8score2" id="qc8score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
             <label style="font-weight: bold;font-size: 20px;">Question 9</label>  Passive range of motion exercises are done: <hr />
            Al rango pasivo de ejercicios de movimiento lo hace:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question9"  value="1" required/>Completely by the client.
                        &#047; &#047;&#047;El cliente solo.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question9"  value="2" required/>Completely by the Aide for the client.
                        &#047; &#047;&#047;El ayudante solo por el cliente.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question9"  value="3" required/>Completely by machine.
                        &#047; &#047;&#047;S&#0243;lo la m&#0225;quina.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question9"  value="4" required/>Paritally by the machine and partially by the client.
                        &#047; &#047;&#047;Parcialmente la m&#0225;quina y parcialmente el cliente.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add9c" name="add9c" value=""/>
        <input type="hidden" name="qc9score2" id="qc9score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 10</label>  The normal oral temperature (Fahrenheit) is: <hr />
            La temperatura oral normal (en grados Fahrenheit) es:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label><input type="radio" formControlName="Question10"  value="1" required/>96.8</label>
                </li>
                <li>
                    <label><input type="radio" formControlName="Question10"  value="2" required/>98.6</label>
                </li>
                <li>
                    <label><input type="radio" formControlName="Question10"  value="3" required/>99.8</label>
                </li>
                <li>
                    <label><input type="radio" formControlName="Question10"  value="4" required/>100.0</label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add10c" name="add10c" value=""/>
        <input type="hidden" name="qc10score2" id="qc10score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 11</label>  Your client's temperature when taken orally is 100 degrees, You should: <hr />
            Cuando le toma Ia temperatura oral al cliente, tiene 100 grados. Usted debe:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question11"  value="1" required/>Tell her this is normal and continue with your work.
                        &#047; &#047; &#047;Decirle que es normal y seguir con el trabajo.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question11"  value="2" required/>Tell her this is a high fever, but it will come down.
                        &#047; &#047; &#047; Decirle que tiene alta la temperatura, pero que ya bajar&#0225;.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question11"  value="3" required/>Tell her that her temperature is slightly higher than normal and that you will call your supervisor.
                        &#047; &#047; &#047; Decirle que tiene la temperatura levemente m&#047; &#047; &#047;s alta que lo normal y que llamar&#047; &#047; &#047; al supervisor.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question11"  value="4" required/>Call an ambulance immediately.
                        &#047; &#047; &#047; Llamar a una ambulancia de inmediato.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add11c" name="add11c" value=""/>
        <input type="hidden" name="qc11score2" id="qc11score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 12</label>  The normal adult pulse rate recorded for one minute is: <hr />
            El pulso normal en las personas adultas por minuto es:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question12"  value="1" required/>110 to 130
                        &#047; &#047; &#047; 110 a 130
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question12"  value="2" required/>16 to 20
                        &#047; &#047; &#047; 16 a 20
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question12"  value="3" required/>70 to 90
                        &#047; &#047; &#047; 70 a 90
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question12"  value="4" required/>25 to 40
                        &#047; &#047; &#047; 25 a 40
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add12c" name="add12c" value=""/>
        <input type="hidden" name="qc12score2" id="qc12score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 13</label>  The normal adult respiration is: <hr />
            La respiraci&#0243;n normal en las personas adultas es:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question13"  value="1" required/>14 to 20
                        &#047; &#047; &#047; 14 a 20
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question13"  value="2" required/>5 to 10
                        &#047; &#047; &#047; 5 a 10
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question13"  value="3" required/>10 to 15
                        &#047; &#047; &#047; 10 a 15
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question13"  value="4" required/>25 to 30
                        &#047; &#047; &#047; 25 a 30
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add13c" name="add13c" value=""/>
        <input type="hidden" name="qc13score2" id="qc13score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 14</label>  A urinary catheter is: <hr />
            Un cat&#0233;ter urinario es:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question14"  value="1" required/>An infection of the urinary tract.
                        &#047; &#047; &#047; Una infecci&#0243;n del tracto urinario.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question14"  value="2" required/>A bag used to collect waste from the intestines.
                        &#047; &#047; &#047; Una bolsa que se utiliza para recoger los desechos de los intestinos.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question14"  value="3" required/>A bedpan designed to collect urine.
                        &#047; &#047; &#047; Una chata dise&#0241;iada para recoger la orina.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question14"  value="4" required/>A tube inserted into the bladder to drain urine.
                        &#047; &#047; &#047; Un tubo insertado en la vejiga para drenar la orina.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add14c" name="add14c" value=""/>
        <input type="hidden" name="qc14score2" id="qc14score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 15</label>  Care of a patient with a catheter includes: <hr />
            El cuidado de una persona que tiene un cat&#0233;ter incluye:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question15"  value="1" required/>Washing the client's skin area surrounding the catheter.
                        &#047; &#047; &#047; Lavar la zona de la piel del cliente alrededor del cat&#0233;ter.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question15"  value="2" required/>Wiping the catheter tube with an antiseptic swab, making one stroke per swab.
                        &#047; &#047; &#047; Limpiar el tubo del cateter con un hisopo antis&#0233;ptico, con una pasada por hisopo.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question15"  value="3" required/>Starting at the urinary opening and wiping towards the drainage bag.
                        &#047; &#047; &#047; Comenzar en la abertura urinaria y limpiar hacia la bolsa de drenaje.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question15"  value="4" required/>All of the above.
                        &#047; &#047; &#047; Todo lo anterior.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add15c" name="add15c" value=""/>
        <input type="hidden" name="qc15score2" id="qc15score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 16</label>  An Aide's hands should be washed: <hr />
            El ayudante debe lavarse las manos:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question16"  value="1" required/>After blowing his/her nose.
                        &#047; &#047; &#047; Despu&#0233;s de sonarse la nariz.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question16"  value="2" required/>After using the bathroom.
                        &#047; &#047; &#047; Despu&#0233;s de usar el ba&#0241;o.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question16"  value="3" required/>Before preparing food.
                        &#047; &#047; &#047; Antes de preparar la comida.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question16"  value="4" required/>All of the above.
                        &#047; &#047; &#047; Todo lo anterior.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add16c" name="add16c" value=""/>
        <input type="hidden" name="qc16score2" id="qc16score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 17</label>  The best way for an Aide to prevent infection from spreading is: <hr />
            La mejor forma para que un ayudante prevenga que una infecci&#0243;n se propague es:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question17"  value="1" required/>Air the client's room.
                        &#047; &#047; &#047; Ventilar la habitaci&#0243;n del cliente.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question17"  value="2" required/>Damp dust the client's room.
                        &#047; &#047; &#047; Humedecer el polvo en la habitaci&#0243;n del cliente.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question17"  value="3" required/>Wash hands before and after each client contact.
                        &#047; &#047; &#047; Lavarse las manos antes y despu&#0233;s de cada contacto con el cliente.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question17"  value="4" required/>Change linens daily.
                        &#047; &#047; &#047; Cambiar las s&#0225;banas a diario.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add17c" name="add17c" value=""/>
        <input type="hidden" name="qc17score2" id="qc17score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 18</label>  Gloves should be worn whenever: <hr />
            Se deben usar guantes siempre que:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question18"  value="1" required/>Working with a patient where there is exposure to blood, feces or urine.
                        &#047; &#047; &#047; Se trabaje con un paciente donde haya una exposici&#0243;n a sangre, heces u orina.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question18"  value="2" required/>Assisting a patient with ambulation.
                        &#047; &#047; &#047; Ayudar al paciente a moverse.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question18"  value="3" required/>Feeding a patient.
                        &#047; &#047; &#047; Dar de comer al paciente.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question18"  value="4" required/>Preparing a meal for a patient
                        &#047; &#047; &#047; Preparar una comida para un paciente.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add18c" name="add18c" value=""/>
        <input type="hidden" name="qc18score2" id="qc18score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 19</label>  Before doing a non-sterile dressing change, a Home Health Aide must: <hr />
            Antes de hacer un cambio de vendajes no esterilizados, un ayudante de salud en el hogar debe:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question19"  value="1" required/>Wash his/her/hands
                        &#047; &#047; &#047; Lavarse las manos.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question19"  value="2" required/>Wear gloves
                        &#047; &#047; &#047; Usar guantes.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question19"  value="3" required/>Check the client's plan of care
                        &#047; &#047; &#047; Revisar el plan de atenci&#0243;n del cliente.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question19"  value="4" required/>All of the above
                        &#047; &#047; &#047; Todo lo anterior.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add19c" name="add19c" value=""/>
        <input type="hidden" name="qc19score2" id="qc19score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 20</label>  The MOST important reason to keep the client's area clean is that: <hr />
            El motivo M&#0193;S importante para mantener limpia el area del cliente es que:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question20"  value="1" required/>A clean house looks neater and smells better
                        &#047; &#047; &#047; Un hogar limpio se ve m&#0225;s prolijo y huele mejor.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question20"  value="2" required/>A family is more comfortable in a clean, neat home
                        &#047; &#047; &#047; Una familia est&#0225; m&#0225;s c&#0243;moda en un hogar limpio y prolijo.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question20"  value="3" required/>A clean home provides good morale
                        &#047; &#047; &#047; Un hogar limpio ofrece una buena moral.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question20"  value="4" required/>It lessens the danger of infection to the client
                        &#047; &#047; &#047; Disminuye el peligro de infecci&#0243;n para el cliente.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add20c" name="add20c" value=""/>
        <input type="hidden" name="qc20score2" id="qc20score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 21</label> When doing the laundry or cleaning, you should never:<hr />
            Cuando lava la ropa o hace la limpieza, nunca debe:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question21"  value="1" required/>Wear gloves.
                        &#047; &#047; &#047; Usar guantes.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question21"  value="2" required/>Vacuum in a room where a patient is in bed.
                        &#047; &#047; &#047; Pasar la aspiradora en una habitaci&#0243;n donde el paciente est&#0233; acostado.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question21"  value="3" required/>Mix bleach with ammonia.
                        &#047; &#047; &#047; Mezclar lavandina con amon&#0237;aco.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question21"  value="4" required/>All of the above.
                        &#047; &#047; &#047; Todo lo anterior.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add21c" name="add21c" value=""/>
        <input type="hidden" name="qc21score2" id="qc21score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 22</label> When feeding a client that cannot feed him/herself, it is important to: <hr />
            Cuando d&#0233; de comer a un cliente que no puede comer solo, es importante que:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question22"  value="1" required/>Feed slowly in small amounts.
                        &#047; &#047; &#047; Le d&#0233; peque&#0241;as cantidades de comida.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question22"  value="2" required/>Make sure that the food is not too hot or too cold.
                        &#047; &#047; &#047; Se asegure de que la comida no est&#0233; demasiado fria ni demasiado caliente.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question22"  value="3" required/>Not to rush the client.
                        &#047; &#047; &#047; No apure al cliente.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question22"  value="4" required/>All of the above.
                        &#047; &#047; &#047; Todo lo anterior.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add22c" name="add22c" value=""/>
        <input type="hidden" name="qc22score2" id="qc22score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 23</label> Which of the following would be the best breakfast for a client on a low salt diet? <hr />
            &#0191;Cu&#0225;l es los siguientes alimentos ser&#0237;a el mejor para un cliente con una dieta con bajos contenidos de sal?
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question23"  value="1" required/>Eggs, bacon, buttered toast, orange juice and milk
                        &#047; &#047; &#047; Huevos, tocino, tostada con manteca, jugo de naranja y leche.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question23"  value="2" required/>Shredded wheat with milk and banana and orange juice
                        &#047; &#047; &#047; Cereal para desayuno con Ieche y banana y jugo de naranja.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question23"  value="3" required/>Grilled cheese sandwich and tomato juice
                        &#047; &#047; &#047; Un s&#0225;ndwich de queso gratinado y jugo de tomate.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question23"  value="4" required/>Pancakes with syrup, sausages, grapefruit and milk
                        &#047; &#047; &#047; Crepes con jarabe, salchichas, toronja y Ieche.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add23c" name="add23c" value=""/>
        <input type="hidden" name="qc23score2" id="qc23score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 24</label> A diabetic diet should include: <hr />
            Una dieta para diab&#0233;ticos debe incluir:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question24"  value="1" required/>Pancakes with syrup.
                        &#047; &#047; &#047; Crepes conjarabe.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question24"  value="2" required/>Canned peaches in heavy syrup.
                        &#047; &#047; &#047; Duraznos en lata con almibar.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question24"  value="3" required/>Mashed potatoes and gravy.
                        &#047; &#047; &#047; Pur&#0233; de patatas y salsa de came asada.</label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question24"  value="4" required/>Water packed canned fruit or fresh fruit.
                        &#047; &#047; &#047; Fruta en lata con agua o fruta fresca.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add24c" name="add24c" value=""/>
        <input type="hidden" name="qc24score2" id="qc24score2" value=""/>

    </div>


    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 25</label> Milk is a good source of: <hr />
            La leche es una buena fuente de:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question25"  value="1" required/> Fiber.
                        &#047; &#047; &#047; Fibra.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question25"  value="2" required/> Potassium.
                        &#047; &#047; &#047; Potasio.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question25"  value="3" required/> Calcium.
                        &#047; &#047; &#047; Calcio.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question25"  value="4" required/> Vitamin C.
                        &#047; &#047; &#047; Vitamina C.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add25c" name="add25c" value=""/>
        <input type="hidden" name="qc25score2" id="qc25score2" value=""/>

    </div>


    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 26</label> Oranges and bananas are excellent sources of: <hr />
            Las naranjas y las bananas son excelentes fuentes de:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question26"  value="1" required/>Iron.
                        &#047; &#047; &#047; Hierro.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question26"  value="2" required/>Cholesterol.
                        &#047; &#047; &#047; Colesterol.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question26"  value="3" required/>Calcium.
                        &#047; &#047; &#047; Calcio.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question26"  value="4" required/>Potassium.
                        &#047; &#047; &#047; Potasio.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add26c" name="add26c" value=""/>
        <input type="hidden" name="qc26score2" id="qc26score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 27</label> Foods that help prevent constipation are: <br /> <hr />
            Los alimentos que ayudan a prevenir Ia constipaci&#0243;n son:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question27"  value="1" required/>Whole grain breads and cereals.
                        &#047; &#047; &#047; Panes y cereales integrales.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question27"  value="2" required/>Raw Vegetables.
                        &#047; &#047; &#047; Verdura cruda.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question27"  value="3" required/>Prune Juice.
                        &#047; &#047; &#047; Jugo de ciruelas.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question27"  value="4" required/>All of the above.
                        &#047; &#047; &#047; Todo lo anterior.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add27c" name="add27c" value=""/>
        <input type="hidden" name="qc27score2" id="qc27score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 28</label> A client who is incontinent has: <hr />
            Un cliente incontinente tiene:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question28"  value="1" required/>A gall bladder condition.
                        &#047; &#047; &#047; Una afecci&#0243;n de la vejiga.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question28"  value="2" required/>Constipation.
                        &#047; &#047; &#047; Constipaci&#0243;n.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question28"  value="3" required/>Diabetes.
                        &#047; &#047; &#047; Diabetes.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question28"  value="4" required/>No control of the bladder muscles.
                        &#047; &#047; &#047; No tiene control de los m&#0250;sculos de la vejiga.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add28c" name="add28c" value=""/>
        <input type="hidden" name="qc28score2" id="qc28score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 29</label> Problems of long period of bed rest include: <hr />
            Los problemas de los periodos prol ongados en la cama incluyen:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question29"  value="1" required/>Contractures.
                        &#047; &#047; &#047; Contracturas.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question29"  value="2" required/>Bedsores.
                        &#047; &#047; &#047; Escaras.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question29"  value="3" required/>Constipation.
                        &#047; &#047; &#047; Constipaci&#0243;n.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question29"  value="4" required/>All of the above.
                        &#047; &#047; &#047; Todo lo anterior.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add29c" name="add29c" value=""/>
        <input type="hidden" name="qc29score2" id="qc29score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 30</label> The position of a bedridden client should be changed: <hr />
            La posici&#0243;n de un cliente postrado en la cama debe cambiarse:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question30"  value="1" required/>Once a day.
                        &#047; &#047; &#047; Una vez por d&#0237;a.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question30"  value="2" required/>Never.
                        &#047; &#047; &#047; Nunca.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question30"  value="3" required/>Every two hours.
                        &#047; &#047; &#047; Cada dos horas.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question30"  value="4" required/>Every twenty minutes.
                        &#047; &#047; &#047; Cada veinte minutos.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add30c" name="add30c" value=""/>
        <input type="hidden" name="qc30score2" id="qc30score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 31</label> When making an occupied bed, the Aide should: <hr />
            Cuando hace una cama que est&#0225; ocupada, el ayudante debe:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question31"  value="1" required/>Move the client to the opposite side of the bed.
                        &#047; &#047; &#047; Mover al cliente al lado opuesto de la cama.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question31"  value="2" required/>Only change the top sheet.
                        &#047; &#047; &#047; S&#0243;lo cambiar la s&#0225;bana superior.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question31"  value="3" required/>Always turn off the television.
                        &#047; &#047; &#047; Siempre apagar el televisor.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question31"  value="4" required/>Never change the bed if the patient feels weak.
                        &#047; &#047; &#047; Nunca cambiar la cama si el paciente se siente d&#0233;bil.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add31c" name="add31c" value=""/>
        <input type="hidden" name="qc31score2" id="qc31score2" value=""/>

    </div>


    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 32</label> Mrs. Johnson has difficulty breathing and she has an oxygen tank in her room.  It is important to remember that: <hr />
            La Sra. Johnson tiene dificultad para respirar y tiene un tanque de ox&#0237;geno en la habitaci&#0243;n. Es importante recordar que:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question32"  value="1" required/>You should never enter the room while it is operating.
                        &#047; &#047; &#047; Usted nunca debe ingresar en la habitaci&#0243;n cuando est&#0233; en funcionamiento.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question32"  value="2" required/>The oxygen is very inexpensive, so you can leave it on even when she does not need it.
                        &#047; &#047; &#047; El ox&#0237;geno es muy econ&#0243;mico, de modo que lo puede dejar encendido cuando no lo necesita.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question32"  value="3" required/>No smoking or sparks of any kind should be around the oxygen or a fire could start.
                        &#047; &#047; &#047; No fumar o no hacer chispas de ning&#0250;n tipo cerca del ox&#0237;geno, ya que podr&#0237;a iniciarse un incendio.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question32"  value="4" required/>None of the above.
                        &#047; &#047; &#047; Ninguna de las opciones anteriores.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add32c" name="add32c" value=""/>
        <input type="hidden" name="qc32score2" id="qc32score2" value=""/>

    </div>


    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 33</label> In case of poisoning, the following should be contacted first: <hr />
            En caso de envenenamiento, primero se deber&#0225; llamar a:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question33"  value="1" required/>A family member.
                        &#047; &#047; &#047; Un familiar.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question33"  value="2" required/>A neighbor.
                        &#047; &#047; &#047; Un vecino.
                    </label>
                </li>
                <li>
                    <label><input type="radio" formControlName="Question33"  value="3" required/>911. </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question33"  value="4" required/>A taxi.
                        &#047; &#047; &#047; Un taxi.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add33c" name="add33c" value=""/>
        <input type="hidden" name="qc33score2" id="qc33score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 34</label> Shock is usually caused by which of the following? <hr />
            &#0191;Generalmente un shock es causado por cu&#0225;l de las siguientes opciones?
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question34"  value="1" required/>A broken bone.
                        &#047; &#047; &#047; Un hueso fracturado.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question34"  value="2" required/>Thirst.
                        &#047; &#047; &#047; Sed.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question34"  value="3" required/>Severe Bleeding.
                        &#047; &#047; &#047; Sangrado intenso.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question34"  value="4" required/>Overeating.
                        &#047; &#047; &#047; Comer de m&#0225;s.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add34c" name="add34c" value=""/>
        <input type="hidden" name="qc34score2" id="qc34score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 35</label> Symptoms of heart attack can include:  <hr />
            Los s&#0237;ntomas de un ataque cardiaco pueden incluir:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question35"  value="1" required/>Chest, jaw, or left arm pain.
                        &#047; &#047; &#047; Dolor en el pecho, la mand&#0237;bula o el brazo izquierdo.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question35"  value="2" required/>Shortness of breath.
                        &#047; &#047; &#047; Falta de aire.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question35"  value="3" required/>Indigestion.
                        &#047; &#047; &#047; Indigesti&#0243;n.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question35"  value="4" required/>All of the above.
                        &#047; &#047; &#047; Todo lo anterior.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add35c" name="add35c" value=""/>
        <input type="hidden" name="qc35score2" id="qc35score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 36</label> If a patient complains of pain in the chest and has difficult breathing the Aide should: <hr />
            Si un paciente se queja de tener dolor en el pecho y tiene dificultad para respirar, el ayudante debe:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question36"  value="1" required/>Call the ambulance (911).
                        &#047; &#047; &#047; Llamar a una ambulancia (911).
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question36"  value="2" required/>Call the supervisor.
                        &#047; &#047; &#047; Llamar al supervisor.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question36"  value="3" required/>Have the patient lie down.
                        &#047; &#047; &#047; Hacer que el paciente se acueste.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question36"  value="4" required/>All of the above.
                        &#047; &#047; &#047; Todo lo anterior.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add36c" name="add36c" value=""/>
        <input type="hidden" name="qc36score2" id="qc36score2" value=""/>

    </div>


    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 37</label> Symptoms of a stroke include: <hr />
            Los s&#0237;ntomas de un accidente cerebrovascular incluyen:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question37"  value="1" required/>Blurred vision.
                        &#047; &#047; &#047; Vista borrosa.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question37"  value="2" required/>Severe headache.
                        &#047; &#047; &#047; Dolor de cabeza intenso.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question37"  value="3" required/>Slurred speech.
                        &#047; &#047; &#047; Problemas para hablar.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question37"  value="4" required/>All of the above.
                        &#047; &#047; &#047; Todo lo anterior.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add37c" name="add37c" value=""/>
        <input type="hidden" name="qc37score2" id="qc37score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 38</label> When a diabetic patient is nervous, dizzy, perspiring and appears to be going into insulin shock, the Aide should call the supervisor and give the client: <hr />
            Cuando un paciente diab&#0233;tico est&#0225; nervioso, mareado, transpira y parece que tendr&#0225; un shock insul&#0237;nico, el ayudante debe Hamar al supervisor y dar al cliente:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question38"  value="1" required/>A blanket to keep warm.
                        &#047; &#047; &#047; Una manta para mantenerse caliente.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question38"  value="2" required/>A large glass of water.
                        &#047; &#047; &#047; Un vaso grande de agua.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question38"  value="3" required/>An extra shot of insulin.
                        &#047; &#047; &#047; Una inyecci&#0243;n extra de insulina.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question38"  value="4" required/>A glass of orange juice with sugar.
                        &#047; &#047; &#047; Un vaso de jugo de naranja con az&#0250;car.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add38c" name="add38c" value=""/>
        <input type="hidden" name="qc38score2" id="qc38score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 39</label> Home Health Aides are not permitted to: <hr />
            A los ayudantes de salud en el hogar nose les permite:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question39"  value="1" required/>Bathe a patient with bedsores.
                        &#047; &#047; &#047; Ba&#0241;ar a un paciente con escaras.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question39"  value="2" required/>Take a patient's temperature.
                        &#047; &#047; &#047; Tomar la temperatura de un paciente.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question39"  value="3" required/>Cut toe nails.
                        &#047; &#047; &#047; Cortarle las u&#0241;as de los pies.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question39"  value="4" required/>Transfer a patient from the bed to the wheelchair.
                        &#047; &#047; &#047; Pasar a un paciente de la cama a la silla de ruedas.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add39c" name="add39c" value=""/>
        <input type="hidden" name="qc39score2" id="qc39score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 40</label> Which of the following is the WRONG thing to do? <hr />
            &#0191;Cu&#0225;l de las siguientes acciones es INCORRECTA?
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question40"  value="1" required/>Discuss your patients with family and friends.
                        &#047; &#047; &#047; Conversar sobre los pacientes con familiares y amigos.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question40"  value="2" required/>Talk to your patient while bathing them.
                        &#047; &#047; &#047; Hablar con el paciente mientras lo ba&#0241;a.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question40"  value="3" required/>Allow your patients to talk about their past.
                        &#047; &#047; &#047; Permitir a los pacientes hablar del pasado.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question40"  value="4" required/>Laugh along with your patient.
                        &#047; &#047; &#047; Re&#0237;r con el paciente.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add40c" name="add40c" value=""/>
        <input type="hidden" name="qc40score2" id="qc40score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 41</label>A client accuses you of stealing money, you should:<hr />
            Si un cliente le acusa de robar dinero, usted debe:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question41"  value="1" required/>Argue with the patient.
                        &#047; &#047; &#047; Discutir con el paciente.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question41"  value="2" required/>Call the police.
                        &#047; &#047; &#047; Llamar a la polic&#0237;a.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question41"  value="3" required/>Call your supervisor immediately.
                        &#047; &#047; &#047; Llamar al supervisor de inmediato.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question41"  value="4" required/>Tell your client he/she is confused and there is no money missing.
                        &#047; &#047; &#047; Decirle al cliente que est&#0225; confundido y que no falta dinero.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add41c" name="add41c" value=""/>
        <input type="hidden" name="qc41score2" id="qc41score2" value=""/>

    </div>


    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 42</label>Which of the following is TRUE? <hr />
            &#0191;Cu&#0225;l de las siguientes afirmaciones es VERDADERA?
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question42"  value="1" required/>It is appropriate to ignore a confused client when he/she complains to you.
                        &#047; &#047; &#047; Es adecuado ignorar a un cliente confundido cuando se queja.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question42"  value="2" required/>A person over the age of 65 cannot learn anything new.
                        &#047; &#047; &#047; Una persona mayor de 65 a&#0241;os no puede aprender nada nuevo.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question42"  value="3" required/>All older people are irritable most of the time.
                        &#047; &#047; &#047; Todas las personas mayores son irritables la mayor parte del tiempo.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question42"  value="4" required/>None of the above.
                        &#047; &#047; &#047; Ninguna de las opciones anteriores.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add42c" name="add42c" value=""/>
        <input type="hidden" name="qc42score2" id="qc42score2" value=""/>

    </div>


    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 43</label>Which of the following is TRUE? <hr />
            &#0191;Cu&#0225;l de las siguientes afirmaciones es VERDADERA?
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question43"  value="1" required/>If a dying person has hope of a cure or miracle,it is a good idea to tell them that they are not being realistic.
                        &#047; &#047; &#047; Si una persona moribunda tiene esperazas de una cura o de un milagro, decirle que no es realista es una buena idea.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question43"  value="2" required/>Older people lose their need for privacy.
                        &#047; &#047; &#047; Las personas mayores pierden su necesidad de la privacidad.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question43"  value="3" required/>Most older people feel more comfortable being treated like a child.
                        &#047; &#047; &#047; La mayor&#0237;a de las personas mayores se sienten m&#0225;s c&#0243;modas cuando las tratan como a ni&#0241;os.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question43"  value="4" required/>None of the above.
                        &#047; &#047; &#047; Ninguna de las opciones anteriores.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add43c" name="add43c" value=""/>
        <input type="hidden" name="qc43score2" id="qc43score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 44</label>Which of the following is TRUE? <hr />
            &#0191;Cu&#0225;l de las siguientes afirmaciones es VERDADERA?
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question44"  value="1" required/>All older people prefer to be left alone.
                        &#047; &#047; &#047; Todas las personas mayores prefieren quedarse solas.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question44"  value="2" required/>All older people experience a loss of hearing.
                        &#047; &#047; &#047; Todas las personas mayores pierden la audici&#0243;n.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question44"  value="3" required/>Some older people experience a decreased sense of touch and can suffer burns because of it.
                        &#047; &#047; &#047; Algunas personas mayores pierden el sentido del tacto y en consecuencia, pueden sufrir quemadoras.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question44"  value="4" required/>All people grow less polite as they get older.
                        &#047; &#047; &#047; Todas las personas se vuelven menos amables cuando envejecen.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add44c" name="add44c" value=""/>
        <input type="hidden" name="qc44score2" id="qc44score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 45</label>You have been told by your supervisor to give Mrs. Edwards a bath <br />as part of her morning care but Mrs. Edwards is tired and does not want a bath.
            Your best response would be: <hr />
            El supervisor le ha pedido que le d&#0233; un ba&#0241;o a la Sra. Edwards como parte del cuidado matutino, pero ella est&#0225; cansada y no quiere el ba&#0241;o. Su mejor respuesta deber&#0237;a ser:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question45"  value="1" required/>&ldquo;No excuses, Mrs. Edwards, it's time for your bath&rdquo;
                        &#047; &#047; &#047; &ldquo;No hay excusas, Sra. Edwards, es el momento del ba&#0241;o&rdquo;
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question45"  value="2" required/>&ldquo;I see you would rather not bathe now, we can wait a bit&rdquo;
                        &#047; &#047; &#047; &ldquo;Veo que preferiria no ba&#0241;arse ahora. Podemos esperar un rato&rdquo;
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question45"  value="3" required/>&ldquo;I have a lot to do today, I have to bathe you now&rdquo;
                        &#047; &#047; &#047; &ldquo;Tengo mucho que hacer hoy. Tengo que ba&#0241;arla ahora&rdquo;
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question45"  value="4" required/>&ldquo;Okay, but now you can't have dessert&rdquo;
                        &#047; &#047; &#047; &ldquo;Est&#0225; bien. Pero ahora no comer&#0225; postre&rdquo;
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add45c" name="add45c" value=""/>
        <input type="hidden" name="qc45score2" id="qc45score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 46</label>Your client refuses to eat saying she is just not hungry . You know it is very
            important that she eats her meal. Your best response would be: <hr />
            El cliente se niega a comer y dice que no tiene hambre. Usted sabe que es muy importante que coma. Su mejor respuesta deber&#0237;a ser:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question46"  value="1" required/>&ldquo;If you don't want to eat, you don't have to&rdquo;
                        &#047; &#047; &#047; &ldquo;Si no quiere comer, no tiene que hacerlo.&rdquo;
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question46"  value="2" required/>&ldquo;I spent a lot of time preparing your lunch, so you have to eat it now&rdquo;
                        &#047; &#047; &#047; &ldquo;Pas&#0233; mucho tiempo prepar&#0225;ndole el almuerzo, as&#0237; que ahora lo tiene que comer &rdquo;
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question46"  value="3" required/>&ldquo;Maybe you would like to wait a while. I can serve you lunch a little later&rdquo;
                        &#047; &#047; &#047; &ldquo;Quiz&#0225;s quisiera esperar un rato. Puedo servirle el almuerzo un poco m&#0225;s tarde&rdquo;
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question46"  value="4" required/>All of the above
                        &#047; &#047; &#047; Todo lo anterior.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add46c" name="add46c" value=""/>
        <input type="hidden" name="qc46score2" id="qc46score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 47</label>When a client becomes angry, the Aide should:<hr />
            Cuando un cliente se enoja, el ayudante debe:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question47"  value="1" required/>Shout back at the client.
                        &#047; &#047; &#047; Contestarle gritando al cliente.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question47"  value="2" required/>Quietly continue giving care and try to calm the client.
                        &#047; &#047; &#047; Seguir brindando la atenci6&#0243;n con tranquilidad y tratar de calmar al paciente.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question47"  value="3" required/>Slap the client to calm him/her down.
                        &#047; &#047; &#047; Darle una bofetada al cliente para calmarlo.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question47"  value="4" required/>Stop talking to the client.
                        &#047; &#047; &#047; Dejar de hablarle al cliente.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add47c" name="add47c" value=""/>
        <input type="hidden" name="qc47score2" id="qc47score2" value=""/>

    </div>


    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 48</label>It is important for a Home Health Aide to document which of the following? <hr />
            &#0191;Cu&#0225;l de las siguientes acciones es importante que documente el ayudante de salud en el hogar?
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question48"  value="1" required/>A change in the client's skin color.
                        &#047; &#047; &#047; Un cambio en el color de piel del cliente.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question48"  value="2" required/>A change in the client's mood.
                        &#047; &#047; &#047; Un cambio en el estado de &#0225;nimo del cliente.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question48"  value="3" required/>A change in the client's appetite.
                        &#047; &#047; &#047; Un cambio en el apetito del cliente.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question48"  value="4" required/>All of the above.
                        &#047; &#047; &#047; Todo lo anterior.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add48c" name="add48c" value=""/>
        <input type="hidden" name="qc48score2" id="qc48score2" value=""/>

    </div>

    <div class="questionContainer  ">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 49</label>A Home Health Aide must write down his/her activities with a patient: <hr />
            Un ayudante de salud en el hogar debe anotar las actividades con un paciente:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question49"  value="1" required/>Once a week
                        &#047; &#047; &#047; Una vez por semana.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question49"  value="2" required/>Every two hours
                        &#047; &#047; &#047; Cada dos horas.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question49"  value="3" required/>Every day that service is provided
                        &#047; &#047; &#047; Todos los d&#0237;as en que se suministra el servicio.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question49"  value="4" required/>Only when there are important changes to report
                        &#047; &#047; &#047; S&#0243;lo cuando hay cambios importantes para informar.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add49c" name="add49c" value=""/>
        <input type="hidden" name="qc49score2" id="qc49score2" value=""/>

    </div>

    <div class="questionContainer">
        <div class="question">
        <label style="font-weight: bold;font-size: 20px;">Question 50</label>A home health aide CANNOT: <hr />
            Un ayudante de salud en el hogar <b>NO PUEDE:</b>
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label>
                    <input type="radio" formControlName="Question50"  value="1" required/>Remind the client that it is time to take their medication.
                        &#047; &#047; &#047; Recordarle al cliente que es el momento de tomar la medicaci&#0243;n.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question50"  value="2" required/>Bring the medication to client.
                        &#047; &#047; &#047; Alcanzarle la medicaci&#0243;n al cliente.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question50"  value="3" required/>Provide appropriate liquids for swallowing medication.
                        &#047; &#047; &#047; Dar los l&#0237;quidos adecuados para tragar la medicaci&#0243;n.
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" formControlName="Question50"  value="4" required/>Administer eye drops.
                        &#047; &#047; &#047; Administrar gotas para los ojos.
                    </label>
                </li>
            </ul>
        </div>

        <input type="hidden" class="add" id="add50c" name="add50c" value=""/>
        <input type="hidden" name="qc50score2" id="qc50score2" value=""/>

    </div>


</div>



            </div>
    </div>

  <br/>

  </div>


  <button type="button" (click) = "decreasePage()" class="btn btn-create"  matStepperPrevious><i class="ace-icon fa fa-arrow-left"></i>Prev Page</button>
  &nbsp;
  <button type="submit"  class="btn btn-primary" >Save and Continue &nbsp;
    <i class="ace-icon fa fa-arrow-right icon-on-right"></i></button>   
    

    <div class="spinner-border text-success" role="status" style="position: absolute; bottom:10;" *ngIf="isfetching === true"></div>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-spinner fa-spin  fa-2x" style="color:blue" *ngIf="isfetching === true"> Saving Data...</i>

    </form>

                   
  

</div>
   